<template>
  <div class="animated fadeIn">
    <template v-if="hasAccess()">
      <slot name="gated-content" />
    </template>
    <template v-else-if="show_access_message">
      <b-alert dismissible fade show variant="danger" class="mb-4">
        <i class="fa fa-ban" /> {{`You do not have access to ${denied_permissions} data.`}}
      </b-alert>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: 'PermissionAlertGate',
  props: {
    permissions: {
      type: [ Array, String ],
      default: () => null
    },
    roles: {
      type: [ Array, String ],
      default: () => null
    },
  },
  computed: {
    ...mapGetters({
      show_access_message: "showAccessMessage"
    }),
    denied_permissions() {
      return typeof this.permissions === "string"
        ? this.permissions
        : this.permissions.join(", ")
    }
  },
  methods: {
    hasAccess() {
      return (AccessControlCheck.checkPermission(this.permissions) && AccessControlCheck.checkRole(this.roles));
    },
  },

}
</script>
